module.exports = __webpack_public_path__ + "img/not-data.b0b283cb.svg";